import { render, staticRenderFns } from "./SolicitudMateriales.vue?vue&type=template&id=071b7cbe&scoped=true"
import script from "./SolicitudMateriales.vue?vue&type=script&lang=js"
export * from "./SolicitudMateriales.vue?vue&type=script&lang=js"
import style0 from "./SolicitudMateriales.vue?vue&type=style&index=0&id=071b7cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b7cbe",
  null
  
)

export default component.exports